import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/language.service';

@Component({
  selector: 'app-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.scss']
})

export class AlertDialogComponent implements OnInit {
  title: string = '';
  message: string = '';
  question: boolean = false;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<AlertDialogComponent>,
    private translate: TranslateService,
    private languageService: LanguageService
  ) { }

  ngOnInit(): void {
    if (localStorage.getItem("language")) {
      this.translate.use(localStorage.getItem("language"));
    }
    this.languageService.languageUpdated.subscribe((lang: string) => {
      this.translate.use(localStorage.getItem(lang));
    });
    this.title = this.data.title;
    this.message = this.data.message;
    this.question = this.data.question;
  }

  cancel() {
    this.dialogRef.close(false);
  }

  sure() {
    this.dialogRef.close(true);
  }
}
